export default {"src":"/_next/static/media/whatsapp-black.6aad781d.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};